import React from 'react';
import { motion } from 'framer-motion';

const ErrorPopup = ({ message, onClose, position }) => (
  <motion.div
    className="error-popup"
    role="alertdialog"
    aria-labelledby="error-title"
    aria-describedby="error-message"
    initial={{ scale: 0 }}
    animate={{ scale: 1 }}
    exit={{ scale: 0 }}
    style={{ left: position.x, top: position.y }}
    drag
    dragMomentum={false}
  >
    <div className="error-header">
      <span id="error-title">⚠️ System Alert</span>
      <button onClick={onClose} aria-label="Close alert">×</button>
    </div>
    <div className="error-content">
      <p id="error-message">{message}</p>
      <button onClick={onClose}>OK</button>
    </div>
  </motion.div>
);

export default ErrorPopup;
